import { or } from '@lumapps/utils/function/predicate/or';
import { isQuoteBlock } from '@lumapps/wrex-quote/utils/isQuoteBlock';
import { isCodeBlock } from '@lumapps/wrex-typography/utils/isCodeBlock';
import { isParagraph } from '@lumapps/wrex-typography/utils/isParagraph';

export const isAllowedInAlignedWrapper = or(isParagraph, isQuoteBlock, isCodeBlock);
